import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import StarryBackground from "./components/StarryBackground";
import StoryStudio from "./pages/StoryStudio";
import { SettingsProvider } from "./context/SettingsContext";

function App() {
  return (
    <div className="App">
      <StarryBackground />
      <SettingsProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<StoryStudio />} />
          </Routes>
        </BrowserRouter>
      </SettingsProvider>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#131C38",
            border: "1px solid rgba(251,191,36,0.3)",
            color: "#F8FAFC",
            fontFamily: "Quicksand, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
